module.exports = new __parcel__URL__("jpd-header.4a95c371.svg").toString();